import { createRouter, createWebHistory } from 'vue-router'
import initView from '../views/initView.vue'
import homeView from '../views/homeView.vue'
import termsView from '../views/termsView.vue'
import regionView from '../views/regionView.vue'
import productsView from '../views/productsView.vue'
// import resultView from '../views/resultView.vue'
// import reView from '../views/reView.vue'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/',
    name: 'init',
    component: initView,
    children: [
      {
        path: '/home',
        name: 'home',
        component: homeView
      },
      {
        path: '/terms',
        name: 'terms',
        component: termsView
      },
      {
        path: '/region',
        name: 'region',
        component: regionView
      },
      {
        path: '/products',
        name: 'products',
        component: productsView
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory('/'),
  routes
})
router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  // 戻るボタンで特定のパスに戻ろうとした場合
  // if (from.path === '/' && to.path === '/') {
  if (auth.bsw === '0') {
    alert('戻るボタンは使用できせん')
    next(false) // 遷移をキャンセル
  } else {
    next() // 通常通り遷移
  }
})

export default router
